// extracted by mini-css-extract-plugin
module.exports = {"boxContainer":"styles_boxContainer__EYAUe","p5":"styles_p5__ECoVf"};